<template>
  <div class="px-2 overflow-y-auto scrollbar h-full">
    <div class="sticky top-0 z-10 bg-white pb-1">
      <div class="h-10 bg-blue-20 px-2 flex items-center justify-between w-full">
        <p id="summary-model-id" class="text-xs" qaid="customization-summary-header-model">
          {{ bikeData.modelName }}
        </p>
        <p class="text-sm font-medium" qaid="customization-summary-header-price">
          {{ bikeData.calculatedAdvertised }}
        </p>
      </div>
    </div>

    <pdl-callout v-if="hasBikeBeenSubmittedToRetailer" kind="default" class="mt-2">
      <template #content>
        <span>{{ $t('projectOne.config.summary.orderSubmitted') }}</span>
      </template>
    </pdl-callout>

    <!--base and estimated build prices-->
    <customization-summary-item :items="buildPrices" :is-price-section="true">
      <template #list-item-content>
        <p class="text-xs text-gray-60 leading-tight pb-1" qaid="customization-summary-exclusion-text">
          {{ $t('projectOne.order.estimatedPrice.excluding') }}
        </p>
      </template>
    </customization-summary-item>
    <!-- size -->
    <customization-summary-item :title="$t('text.variant.size')">
      <template #list-item-content>
        <pdl-callout qaid="customization-summary-size-callout">
          <template #content>
            {{ $t('product.fdp.customizable.size.message') }}
          </template>
        </pdl-callout>
      </template>
    </customization-summary-item>
    <!-- color -->
    <customization-summary-item :title="$t('text.order.color')" :items="colorItem" />
    <!-- components -->
    <customization-summary-item
      :title="$t('projectOne.buyingZone.customization.components')"
      :items="componentItems"
      class="border-b-0"
    />

    <div class="sticky bottom-0 bg-white pt-1 pb-2">
      <customization-submit-to-retailer-button />
      <div class="grid grid-cols-2 gap-2 py-1">
        <customization-share-dropdown />
        <customization-save-button />
      </div>
    </div>
  </div>
</template>

<script>
import {mapState, mapGetters} from 'vuex';
import CustomizationSubmitToRetailerButton from '@/components/containers/buy-zone/customization/CustomizationSubmitToRetailerButton.vue';
import CustomizationSummaryItem from '@/components/containers/buy-zone/customization/CustomizationSummaryItem.vue';
import {PdlCallout} from '@pedal/pdl-callout';
import CustomizationShareDropdown from '@/components/containers/buy-zone/customization/CustomizationShareDropdown.vue';
import CustomizationSaveButton from '@/components/containers/buy-zone/customization/CustomizationSaveButton.vue';

export default {
  name: 'CustomizationBuildSummaryBody',
  components: {
    CustomizationSubmitToRetailerButton,
    CustomizationSummaryItem,
    PdlCallout,
    CustomizationShareDropdown,
    CustomizationSaveButton,
  },
  computed: {
    ...mapState('bikeCustomization', [
      'bikeData',
      'isCustomizationSummaryDialogOpen',
      'componentOptions',
      'selections',
      'themeOptions',
    ]),
    ...mapGetters('bikeCustomization', ['selections', 'selectedInspiration', 'hasBikeBeenSubmittedToRetailer']),

    buildPrices() {
      return [
        {
          name: this.$t('projectOne.order.basePrice'),
          price: this.bikeData?.defaultAdvertised,
        },
        {
          name: this.$t('projectOne.order.estimatedPrice'),
          price: this.bikeData?.calculatedAdvertised,
        },
      ];
    },
    colorItem() {
      const inspirationPrice = this.selectedInspiration?.advertisedPrice;

      return [
        {
          name: this.bikeData?.themeName,
          price: inspirationPrice || '',
        },
      ];
    },
    componentItems() {
      let items = [];
      this.componentOptions.forEach((option) => {
        let currentlySelected = {name: '', price: ''};

        const currentSelectionId = this.selections.find((selection) => selection.groupId === option.id)?.choiceId;
        const currentChoice = option.choices.find((choice) => choice.id === currentSelectionId);

        currentlySelected.name = option?.description;
        currentlySelected.choice = currentChoice?.description;
        currentlySelected.price = currentChoice?.priceDifferenceAdvertised;

        items.push(currentlySelected);
      });
      return items;
    },
  },
  mounted() {
    this.$emit('body-mounted');
  },
};
</script>

<style lang="scss" scoped>
:deep(.pdl-callout) {
  margin-bottom: 0.25rem;
}

.scrollbar {
  scrollbar-gutter: stable both-edges;
  scrollbar-width: thin;
}
</style>
